<template>
  <div id="statisticView">
    <div class="head_title">
      <div class="key" v-translateIn>{{ $t("home.HOME_QUESTION") }}</div>
    </div>
    <div
      class="static_content"
      :style="{
        'grid-template-columns': shrink ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)',
        'grid-template-rows': shrink ? 'repeat(5, 1fr)' : 'repeat(3, 1fr)',
      }"
    >
      <div
        class="static_center"
        :style="{
          gridRow: shrink ? '1' : '2/3',
          width: shrink ? '100%' : '80%',
        }"
      > 
        <img src="@/assets/liquid_cooling_center.png" alt="" />
      </div>
      <div
        class="static_card"
        :id="'move_card' + index"
        v-for="(data, index) in staticData"
        :key="data.title"
        :style="{
          gridRow: shrink ? '1' : '2/3',
          width: shrink ? '100%' : '80%',
          position: 'relative',
          overflow: 'hidden',
        }"
      >
        <div
          class="static_card_background"
          :style="{ backgroundImage: 'url(' + data.backgroundImage + ')' }"
        ></div>
        <div class="static_count">
          <div class="count" v-countUp="data.count"></div>
          <div class="unit">{{ data.unit }}</div>
        </div>
        <div class="title">{{ data.title }}</div>
        <div class="describe">{{ data.describe }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import { onMounted, inject, ref, computed, watch, nextTick } from "vue";
import provide_key from "@/constant/provide_key";
import { useI18n } from "vue-i18n";

gsap.registerPlugin(ScrollTrigger);
const shrink: boolean | undefined = inject(provide_key.SHRINK);
const { t } = useI18n();
const staticData = computed(() => [
  {
    count: 300,
    unit: "%",
    title: t("home.STATIC_TITLE_1"),
    describe: t("home.STATIC_DESCRIBE_1"),
    backgroundImage: require("@/assets/increase.png"),
  },
  {
    count: "1.1",
    unit: "",
    title: t("home.STATIC_TITLE_2"),
    describe: t("home.STATIC_DESCRIBE_2"),
    backgroundImage: require("@/assets/power.png"),
  },
  {
    count: 75,
    unit: "%",
    title: t("home.STATIC_TITLE_3"),
    describe: t("home.STATIC_DESCRIBE_3"),
    backgroundImage: require("@/assets/space.png"),
  },
  {
    count: 80,
    unit: "%",
    title: t("home.STATIC_TITLE_4"),
    describe: t("home.STATIC_DESCRIBE_4"),
    backgroundImage: require("@/assets/noise.png"),
  },
]);

onMounted(() => {
  const t1 = gsap.timeline({
    scrollTrigger: {
      trigger: ".static_center",
      start: "top 80%",
      end: "top 50%",
      scrub: 0.001,
    },
  });

  const updateAnimation = () => {
    const unShrinkAnimation = () => {
      t1.to("#move_card0", { x: "-100%", y: "-100%", opacity: 1 }, 0)
        .to("#move_card1", { x: "100%", y: "-100%", opacity: 1 }, 0)
        .to("#move_card2", { x: "-100%", y: "100%", opacity: 1 }, 0)
        .to("#move_card3", { x: "100%", y: "100%", opacity: 1 }, 0);
    };
    const shrinkAnimation = () => {
      t1.to("#move_card0", { y: "100%", opacity: 1 }, 0)
        .to("#move_card1", { y: "200%", opacity: 1 }, 0)
        .to("#move_card2", { y: "300%", opacity: 1 }, 0)
        .to("#move_card3", { y: "400%", opacity: 1 }, 0);
    };
    shrink.value ? shrinkAnimation() : unShrinkAnimation();
  };

  updateAnimation(); // 初始化动画

  watch(
    () => staticData.value,
    () => {
      nextTick(() => {
        t1.restart();
        setTimeout(() => t1.pause(), 500);
        updateAnimation(); // 在数据变化时调用
      });
    }
  );
});
</script>

<style lang="less" scoped>
#statisticView {
  padding: 2rem 4rem 0 4rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  z-index: 3;
  top: 0;
  width: 100%;
  border-top-left-radius: 2rem;
  border-top-right-radius: 2rem;
  background: var(--bg-color-white);
  min-height: 100vh;

  .head_title {
    width: 100%;
    display: flex;
    gap: 1rem;
    max-width: var(--view-max-width);
    overflow: hidden;
    }

    .key {
      font-size: var(--font-size-big);
      font-weight: var(--font-weight-plus);
      color: var(--font-color-black-light);
      border-left: 0.25rem solid var(--font-color-blue-dark);
      padding: 0 1rem;
    }

  .static_content {
    flex: 1;
    gap: 1rem;
    width: 100%;
    overflow: hidden;
    max-width: var(--view-max-width);
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    padding: 0 2rem;
    justify-content: center;
    flex-direction: column;

    .static_center {
      height: 28vh;
      width: 80%;
      border-radius: 2rem;
      overflow: hidden;
      grid-row: 2 / 3;
      grid-column: 2 / 3;
      z-index: 2;
      margin: 0 auto;
      position: relative;

      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .static_card {
      width: 80%;
      margin: 0 auto;
      height: 28vh;
      border-radius: 1rem;
      background-color: #e3e3e3;
      box-shadow: 0 0 10px rgba(0, 0, 10px, 0.3);
      display: flex;
      justify-content: center;
      padding: 1rem 1rem 0 1rem;
      flex-direction: column;
      gap: 0.4rem;
      max-width: 100vw;
      z-index: 1;
      opacity: 0;
      grid-row: 2 / 3;
      grid-column: 2 / 3;
      position: relative;
      overflow: hidden;

      &_background {
        height: 80%;
        width: 80%;
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        opacity: 0.1;
        z-index: 0;
      }

      .static_count {
        display: flex;
        font-size: var(--font-size-medium);
        color: var(--font-color-blue-dark);
        font-weight: var(--font-weight-super);

        .count {
          overflow: hidden;
        }

        .unit {
          overflow: hidden;
        }
      }

      .title {
        font-size: var(--font-size-might);
        color: rgb(25, 60, 95);
        font-weight: var(--font-weight-big);
        overflow-y: hidden;
        white-space: nowrap;
      }

      .describe {
        font-size: var(--font-size-small);
        font-weight: var(--font-weight-base);
        color: var(--font-color-black-light);
        overflow-y: hidden;
      }
    }
  }
}
</style>